(function() {
  var encoding;

  encoding = exports;

  encoding.htmlEncode = function(str, allowedTags, sanitize) {
    if (allowedTags == null) {
      allowedTags = [];
    }
    if (sanitize == null) {
      sanitize = true;
    }
    if (sanitize) {
      str = encoding.sanitize(str);
    }
    str = encoding.limitTags(str, allowedTags);
    str = $('<div/>').text(str).html();
    return str;
  };

  encoding.htmlDecode = function(str, allowedTags, sanitize) {
    if (allowedTags == null) {
      allowedTags = [];
    }
    if (sanitize == null) {
      sanitize = true;
    }
    str = $('<div/>').html(str).text();
    if (sanitize) {
      str = encoding.sanitize(str);
    }
    str = encoding.limitTags(str, allowedTags);
    return str;
  };

  encoding.limitTags = function(str, allowedTags) {
    var dom, selStr;
    if (allowedTags == null) {
      allowedTags = [];
    }
    selStr = '*:not(' + allowedTags.join(',') + ')';
    dom = $('<div/>').html(str);
    dom.find(selStr).replaceWith(function() {
      return $(this).text();
    });
    str = dom.html();
    return str;
  };

  encoding.sanitize = function(str) {
    var dom;
    dom = $('<div/>').html(str);
    dom.find('script,style').remove();
    str = dom.html();
    return str;
  };

}).call(this);
